import React from 'react'
import {dateFormatMonthDayYear} from "../../actions/util";
import {MyPagination} from "../index";
import {isAllow, userActionsKeys} from "../../util/userActions";
import {UsernameDateData} from "./MemberVisitContactList";

const MemberContactList = ({member, memberContactList, memberContactPagination, getMemberContactList, setBigModalTitle, setIsBigModalOpen, setMemberContact}) => {

  return (
    <>
      {memberContactList && memberContactList.length > 0 && memberContactList.map((value, index) => (
        <div key={index + value.id} className="col-12">
          <div>
          <span className={isAllow(userActionsKeys.editMemberContactLegal) ? "simulate-a" : ""} onClick={() => {
            if (isAllow(userActionsKeys.editMemberContactLegal)) {
              setMemberContact(value);
              setBigModalTitle("Edit Contact");
              setIsBigModalOpen(true);
            }
          }}>{value.type} on {dateFormatMonthDayYear(value.date)}</span>
          </div>
          <UsernameDateData value={value}/>

        </div>
      ))}

      {memberContactList.length > 0 && memberContactPagination.count > 10 &&
      <div style={{padding: "30px 15px 0", overflow: "auto"}}>
        <MyPagination count={memberContactPagination.count} limit={memberContactPagination.limit} skip={memberContactPagination.skip} action={(skip, limit) => {
          getMemberContactList(member.id, limit, skip, memberContactPagination.filterName, memberContactPagination.columnSort, memberContactPagination.descending)
        }}/>
      </div>}
    </>
  )
}

export default MemberContactList